import { useState } from 'react';

import { Alert } from '@mui/material';

import { AppBannerContainer } from '@modules/_shared/components/AppBannerContainer';
import { useAppData } from '@modules/_shared/providers/AppDataProvider';
import { isOnboardingPendingReview } from '@modules/_shared/utils/onboardingStatus';
import { useLocale } from '@shared/hooks/locale';

import { createOnboardingUserStorage } from './onboardingStepCompletionStorage';

const onboardingReviewBannerDismissal = createOnboardingUserStorage(
  'crm:onboarding:review-banner-dismissed',
);

// Tells an invited agent who finished onboarding that their profile is being
// reviewed — otherwise they land in the CRM with no idea why they are not
// live yet. Hidden again as soon as the status leaves pending_review.
export const OnboardingStatusBanner = () => {
  const { t } = useLocale();
  const { me } = useAppData();
  const [dismissed, setDismissed] = useState(
    () => me?.id != null && onboardingReviewBannerDismissal.isMarked(me.id),
  );

  if (!isOnboardingPendingReview(me?.onboarding_status) || dismissed) {
    return null;
  }

  const dismiss = () => {
    if (me.id != null) {
      onboardingReviewBannerDismissal.mark(me.id);
    }
    setDismissed(true);
  };

  return (
    <AppBannerContainer>
      <Alert severity="info" onClose={dismiss}>
        {t('Your profile has been submitted and is under review by our team.')}
      </Alert>
    </AppBannerContainer>
  );
};
